import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';
import { DatePicker, Dropdown, Stack } from '@fluentui/react';
import moment from 'moment';
import { IOutcomeResourceShorterProps } from '../../../../../props/finance/outcomes';
import GeneralService from '../../../../../services/general';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IncomesSummaryFilterDate from './date';

// assets

// services

// props

// components

type IncomesSummaryFilterProps = {
    selected: IncomesSummaryFilterData;
    onChange(filter: IncomesSummaryFilterData): void;
}

export type IncomesSummaryFilterData = {
    startDate: string;
    endDate: string;
}

const IncomesSummaryFilter: React.FC<IncomesSummaryFilterProps> = (props: IncomesSummaryFilterProps) => {
    const { banner, user } = useStore();

    const [filter, setFilter] = React.useState<IncomesSummaryFilterData>(props.selected);

    useEffect(() => {
        setFilter({...props.selected});
    }, [props.selected]);

    return <Stack>
        <Stack horizontal tokens={{ childrenGap: 15 }}>
            <IncomesSummaryFilterDate startDate={filter.startDate} endDate={filter.endDate} onChange={(startDate, endDate) => {
                const _filter = filter;
                _filter.startDate = startDate;
                _filter.endDate = endDate;

                props.onChange(_filter);
            }} />
        </Stack>
    </Stack>;
};

export default IncomesSummaryFilter;
